exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chat-webrtc-choosecamera-btn{font-size:1.2em;margin-left:10px;margin-right:10px}.chat-webrtc-choosecamera-question{font-size:1.4em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/styles/chooseCamera.scss
// module id = 1165
// module chunks = 0 1